var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack448({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.67,10.75H7.3v-.36A2.32,2.32,0,0,1,7.52,9.3a3.37,3.37,0,0,1,.88-1,7.5,7.5,0,0,0,.79-.7,1,1,0,0,0,.2-.58A1,1,0,0,0,9,6.29,1.38,1.38,0,0,0,8.09,6a1.42,1.42,0,0,0-1,.33,1.66,1.66,0,0,0-.53,1L5.21,7.13A2.29,2.29,0,0,1,6,5.5a2.89,2.89,0,0,1,2-.67,3,3,0,0,1,2.07.68,2.06,2.06,0,0,1,.77,1.58,1.69,1.69,0,0,1-.28.94A6,6,0,0,1,9.37,9.25a2.25,2.25,0,0,0-.59.64A2.18,2.18,0,0,0,8.67,10.75Zm-1.37,2V11.27H8.81v1.51Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "8 1 0.64 6.35 3.45 15 12.55 15 15.36 6.35 8 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack448);
export default __webpack_public_path__ + "static/media/Symbolpack_4_48.406ea4b852660690b810be2757e8146f.svg";
export { ForwardRef as ReactComponent };